import { render, staticRenderFns } from "./Cupom.vue?vue&type=template&id=83b87878&scoped=true"
import script from "./Cupom.vue?vue&type=script&lang=js"
export * from "./Cupom.vue?vue&type=script&lang=js"
import style0 from "./Cupom.vue?vue&type=style&index=0&id=83b87878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b87878",
  null
  
)

export default component.exports